import styled from "@emotion/styled";

export const RadiosWrapper = styled.fieldset`
  padding: 0;
  margin: 0;
  border: none;
`;
